import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./ExcelReports.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import ReportSectionRenderer from "../../sections/ReportSectionRenderer/ReportSectionRenderer";
import ReportsData from "../../sections/ReportsData/ReportsData";

const ExcelReports = () => {
  const [activeTab, setActiveTab] = useState("Student Attendance");
  const [searchQuery, setSearchQuery] = useState("");

  const modalType = useSelector((state) => state.modal.type); // ✅ Modal type
  const isModalOpen = useSelector((state) => state.modal.isOpen); // ✅ Modal open flag

  // Debug log to help during testing
  useEffect(() => {
    console.log("[ExcelReports] Modal Open:", isModalOpen, "Type:", modalType);
  }, [isModalOpen, modalType]);

  const tabs = [
    { label: "Student Attendance", component: null },
    { label: "Student Info", component: null },
    { label: "Billing", component: null },
    { label: "Staff", component: null },
    { label: "Enquiry", component: null },
    { label: "Admissions", component: null },
    { label: "Form Submission Report", component: null },
    { label: "Activity Report", component: null },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.topbar}>
        <span
          className={styles.clickableText}
          onClick={() => console.log("Topbar clicked")}
        >
          Recently generated reports
        </span>
      </div>

      <div className={styles.background}>
        <div className={styles.header}>
          <SearchBar
            placeholder="Search reports..."
            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.tabContainer}>
            {tabs.map((tab, idx) => (
              <div
                key={idx}
                className={`${styles.tab} ${
                  activeTab === tab.label ? styles.activeTab : ""
                }`}
                onClick={() => setActiveTab(tab.label)}
              >
                <span>{tab.label}</span>
              </div>
            ))}
          </div>

          <div className={styles.reportSection}>
            {ReportsData[activeTab] ? (
              <ReportSectionRenderer
                reports={ReportsData[activeTab]}
                search={searchQuery}
              />
            ) : (
              tabs.find((t) => t.label === activeTab)?.component || null
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcelReports;
